<template>
  <v-card class="rounded-xl" :elevation="2">
    <v-card-title class="py-3">
      <div class="d-flex align-center">
        <v-icon class="mr-2">{{ headIcon }}</v-icon>
        <component
          :is="to ? 'router-link' : 'span'"
          :to="to"
          class="card-title-link"
        >
          {{ title }}
        </component>
      </div>
      <v-spacer />
      <v-progress-circular v-if="loading" indeterminate size="20" width="2" />
    </v-card-title>

    <v-divider />

    <v-card-text class="pt-2">
      <v-simple-table dense>
        <thead>
          <tr>
            <th style="width: 260px">Status</th>
            <th v-for="dep in departments" :key="dep" class="text-right">
              {{ dep }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="r in rows" :key="r.code">
            <td>
              <div class="d-flex align-center">
                <component
                  :is="to ? 'router-link' : 'span'"
                  :to="{ path: to, query: { selectedFilter: r.code } }"
                  class="card-title-link"
                >
                  <v-avatar :color="r.color" size="28" class="mr-3">
                    <span class="white--text text-caption font-weight-bold">
                      {{ r.code == "PA" ? "AG" : r.code }}
                    </span>
                  </v-avatar>
                  <span class="text-body-2">{{ r.label }}</span>
                </component>
              </div>
            </td>

            <td v-for="dep in departments" :key="dep" class="text-right">
              <component
                :is="to ? 'router-link' : 'span'"
                :to="{ path: to, query: { selectedDepartment: dep } }"
                class="card-title-link"
              >
                <v-chip small outlined>
                  {{ getCount(r, dep) }}
                </v-chip>
              </component>
            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <div class="d-flex justify-end mt-2 text-caption grey--text">
        Atualizado {{ updatedAtText }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "StatusCardDept",
  props: {
    title: { type: String, required: true },
    headIcon: { type: String, default: "mdi-view-dashboard" },
    loading: { type: Boolean, default: false },
    updatedAt: { type: Date, default: () => new Date() },
    to: { type: [String, Object], default: null }, // 👈 nova prop

    // estrutura pronta (já transformada)
    departments: { type: Array, default: () => [] }, // ["Central","DME",...]
    rows: { type: Array, default: () => [] }, // [{ code,label,color,counts:{[dep]:n} }]
  },
  computed: {
    updatedAtText() {
      const d = this.updatedAt;
      if (!d) return "--:--";
      return new Intl.DateTimeFormat("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
      }).format(d);
    },
  },
  methods: {
    getCount(row, dep) {
      return row && row.counts && row.counts[dep] ? row.counts[dep] : 0;
    },
  },
};
</script>
<style scoped>
.card-title-link {
  font-weight: 500;
  color: inherit;
  text-decoration: none;
}

.card-title-link:hover {
  text-decoration: underline;
}
</style>